import { __assign, __read } from "tslib";
import { getLocaleNamespace } from '@wix/wixstores-client-core';
import { compact } from '../../lib/compact';
import * as _ from 'lodash';
var MultilingualService = /** @class */ (function () {
    /* istanbul ignore next */
    function MultilingualService(siteStore, publicData, widgetSettings) {
        if (publicData === void 0) { publicData = {}; }
        if (widgetSettings === void 0) { widgetSettings = {}; }
        var _a;
        this.siteStore = siteStore;
        this.publicData = publicData;
        this.widgetSettings = widgetSettings;
        var multiLangFields = (_a = this.siteStore.getMultiLangFields()) !== null && _a !== void 0 ? _a : this.defaultMultiLangFields;
        this.isPrimaryLanguage = multiLangFields.isPrimaryLanguage;
        this.lang = multiLangFields.lang;
        this.locale = multiLangFields.locale;
    }
    Object.defineProperty(MultilingualService.prototype, "defaultMultiLangFields", {
        get: function () {
            return {
                isPrimaryLanguage: true,
                lang: this.siteStore.locale,
                locale: this.siteStore.locale,
            };
        },
        enumerable: false,
        configurable: true
    });
    MultilingualService.prototype.get = function (key) {
        if (this.isPrimaryLanguage) {
            return this.publicData[key];
        }
        else {
            var widgetSettingsTextsMap = this.widgetSettings[getLocaleNamespace(this.lang)];
            return widgetSettingsTextsMap === null || widgetSettingsTextsMap === void 0 ? void 0 : widgetSettingsTextsMap[key];
        }
    };
    MultilingualService.prototype.getAll = function (shouldAddLanguageKeys) {
        if (shouldAddLanguageKeys === void 0) { shouldAddLanguageKeys = false; }
        if (this.isPrimaryLanguage) {
            return this.publicData;
        }
        var localizedNamespace = this.widgetSettings[getLocaleNamespace(this.lang)];
        if (!shouldAddLanguageKeys) {
            return localizedNamespace;
        }
        var languageSuffix = "\u25B6\uFE0El:".concat(this.lang);
        var withLanguageKeys = Object.fromEntries(Object.entries(localizedNamespace !== null && localizedNamespace !== void 0 ? localizedNamespace : {}).map(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            return ["".concat(key).concat(languageSuffix), value];
        }));
        return __assign(__assign({}, localizedNamespace), withLanguageKeys);
    };
    MultilingualService.prototype.setWidgetSettings = function (data) {
        this.widgetSettings = data;
    };
    MultilingualService.prototype.setPublicData = function (data) {
        this.publicData = data;
    };
    MultilingualService.prototype.getMergedTranslationsAsPublicData = function (freeTextFields, shouldAddLanguageKeys) {
        if (shouldAddLanguageKeys === void 0) { shouldAddLanguageKeys = false; }
        var purgedPublicData = _.omit(this.publicData, freeTextFields);
        return compact(_.merge({}, purgedPublicData, this.getAll(shouldAddLanguageKeys)));
    };
    return MultilingualService;
}());
export { MultilingualService };
//# sourceMappingURL=MultilingualService.js.map